import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    resources: {
      en: {
        translation: {
          client: "Client",
          driver: "Driver",
          host: "Host",
          //start header
          gettak: "Gettak",
          home: "Home",
          about: "About",
          contact: "Contact",
          privacy_policy: "Privacy Policy",
          login: "Login",
          //end header

          //start signup & login & otp
          welcome_back_ready_to_hit_the_road: "Welcome Back\nReady to Hit the Road",
          signup: "Don't have an account yet ? Signup",
          download_from_app: "Download App From Store",
          apple: "Apple",
          google: "Google",
          full_name: "Full Name",
          email: "Email",
          password: "Password",
          confirm: "Confirm",
          full_name_required: "Full Name Required",
          invalid_email: "Invalid Email",
          email_required: "Email Required",
          password_lenght: "Password Must be  at least 8 Character",
          password_required: "Password Required",
          phone_lenght: "Phone Must be at least 9 digits and not start with 0",
          phone_required: "Phone Required",
          create_new_account: "Create New Account",
          enter_verification_code: "Enter Verification Code",
          we_have_send_a_code_to: "We have Send a Code to",
          otp: "Verify Your Account",
          //end signup & login & otp

          //start footer
          address: "Address",
          address_info: "Oxford Ave. Cary, NC 27511",
          phone: "Phone",
          email_info: "example@domain.com",
          text_footer: "Gettak Car Rentals offers reliable, affordable, and convenient car rental services. Whether you need a car for a day, a week, or longer, we provide the perfect ride for your journey. Your comfort and safety are our priority.",
          links: "Links",
          download_app: "Download App",
          download_from: "Download From",
          app_store: "App Store",
          google_play: "Google Play",
          copyright: "Copyright",
          rights_reserved: "Developed By AIGate Company. All Rights Reserved",
          //end footer

          //start popup
          front_side: "Front side for Driving License",
          front_image_required: "Front Side for Driving License is Required",
          back_side: "Back side for Driving License",
          background_image_required: "Back Side for Driving License is Required",
          invalid_file_type: "Invalid File Type",
            //client
          billing_address:"Billing Address",
          billing_address_required: "Billing Address Required",
          license_number: "License Number",
          license_number_required: "License Number Required",
          complete_profile_as_a_client: "Complete Profile as a Client",
            //driver
          profile_picture: "Profile Picture",
          picture_required: "Picture Required",
          desired_wage: "Desired Wage",
          desired_wage_required: "Desired Wage Required",
          price_per_hour: "Price Per Hour",
          price_per_hour_required: "Price Per Hour Required",
          extra_hour_price: "Extra Hour Price",
          the_number_must_be_greater_than_zero: "The number must be greater than zero",
          complete_profile_as_a_driver: "Complete Profile as a Driver",
            //host
          is_company: "Is Company?",
          company_name: "Company Name",
          company_name_required: "Company Name Required",
          complete_profile_as_a_host: "Complete Profile as a Host",
          //end popup


          //start profile
          show_web_as_customer: "Show Web as a Customer",
          show_web_as_partner: "Show Web as a Partner",
          personal_info: "Personal Info",
          update_account: "Update Account",
          complete: "Complete",
          complete_and_update: "Complete and Update",
          update: "Update",
          complete_as_client: "Complete as a Client",
          update_as_client: "Update Customer Information",
          complete_as_host: "Complete as a Host",
          update_as_host: "Update Host Information",
          complete_as_driver: "Complete as a Driver",
          update_as_driver: "Update Driver Information",
          //end profile

          //start home
          hero_title_home: `Experience the road
            like never before`,
          hero_desc_home: `Discover your next adventure with Getaak. we’re here to 
            provide you with a seamless car rental experience. 
            Let’s get started on your journey.`,
          view_all_cars:"View All Cars",
          availability: "Availability",
          availability_info:"Our cars are always available when you need them",
          comfort: "Comfort",
          comfort_info: "Enjoy a comfortable ride wherever you go.",
          savings: "Savings",
          savings_info: "Save more with our affordable rental plans",
          our_services: "Our Services",
          car_hire: "Car Hire",
          car_hire_info: "We pride ourselves in always going the extra mile for our customers.",
          car_sales: "Car Sales",
          car_sales_info: "we sale the best luxury cars across the world at a competitive price.",
          hire_driver: "Hire a Driver",
          hire_driver_info: "you want to travel and fell confortable , our drivers are available.",
          best_cars: "Best Cars",
          view_all: "View All",
          seats: "Seats",
          day: "Day",
          week: "Week",
          month: "Month",
          popular_cars: "Popular Cars",
          no_cars: "No Cars Found",

          //end home
        }
      },
      ar: {
        translation: {
          client: "زبون",
          driver: "سائق",
          host: "مالك",
          //start header
          gettak:"جيتك",
          home: "الصفحة الرئيسية",
          about: "من نحن",
          contact: "تواصل معنا",
          privacy_policy: "سياسة الخصوصية",
          login: "تسجيل الدخول",
          //end header

          //start signup & login & otp
          welcome_back_ready_to_hit_the_road: "أهلا بك مرة أخرى\nمستعدًا للانطلاق",
          signup: " ليس لديك حساب بعد ؟ إنشاء حساب",
          download_app: "تنزيل التطبيق من المتجر",
          apple: "آبل",
          google: "غوغل",
          full_name: "الأسم الثلاثي",
          email: "الإيميل",
          password: "كلمة السر",
          cancel: "إلغاء",
          confirm: "تأكيد",
          full_name_required: "الأسم الكامل مطلوب",
          invalid_email: "إيميل غير صالح",
          email_required: "الإيميل مطلوب",
          password_lenght: "كلمة السر يجب أن تكون على الأقل 8 محارف",
          password_required: "كلمة السر مطلوبة",
          phone_lenght: "الرقم يجب أن يكون على الأقل 9 خانات بدون البداية 0",
          phone_required: "الرقم مطلوب",
          create_new_account: "إنشاء حساب جديد",
          we_have_send_a_code_to: "تم إرسال رسالة تأكيد الى الرقم التالي : ",
          otp: "قم بتأكيد حسابك",
          //end signup & login & otp

          //start footer
          address: "العنوان",
          address_info: "شارع أكسفورد، كاري، كارولاينا الشمالية 27511",
          phone: "الهاتف",
          email_info: "example@domain.com",
          text_footer: "تقدم جيتاك لتأجير السيارات خدمات تأجير سيارات موثوقة، بأسعار معقولة، ومريحة. سواءً كنت بحاجة إلى سيارة ليوم أو أسبوع أو لفترة أطول، نوفر لك الرحلة المثالية لرحلتك. راحتك وسلامتك هما أولويتنا.",
          links: "الصفحات الرسمية",
          download_from_app: "تنزيل تطبيق الموبايل",
          download_from: "تنزيل من",
          app_store: "متجر آبل",
          google_play: "متجر غوغل",
          copyright: "حقوق النشر",
          rights_reserved: "تم تطويره من قبل شركة AIGate. جميع الحقوق محفوظة",
          //end footer

          //start popup
          front_side: "صورة أمامية للشهادة",
          front_image_required: "الصورة الأمامية للشهادة مطلوبة",
          back_side: "صورة خلفية للشهادة",
          background_image_required: "الصورة الخلفية للشهادة مطلوبة",
          invalid_file_type: "نوع الملف غير صالح",
              //client
          billing_address:"عنوان الدفع",
          billing_address_required: "عنوان الدفع مطلوب",
          license_number: "رقم الشهادة",
          license_number_required: "رقم الشهادة مطلوب",
          complete_profile_as_a_client: "متابعة التسجيل كزبون",
              //driver
          profile_picture: "صورة الملف الشخصي",
          picture_required: "صورة الملف الشخصي مطلوبة",
          desired_wage: "الراتب المتوقع",
          desired_wage_required: "الراتب المتوقع مطلوب",
          price_per_hour: "السعر لكل ساعة",
          price_per_hour_required: "السعر لكل ساعة مطلوب",
          extra_hour_price: "السعر لكل ساعة اضافية",
          extra_hour_price_required: "السعر لكل ساعة اضافية مطلوب",
          the_number_must_be_greater_than_zero: "الرقم يجب ان يكون اكبر من صفر",
          complete_profile_as_a_driver: "متابعة التسجيل كسائق",
              //host
          is_company: "هل هو شركة؟",
          company_name: "اسم الشركة",
          company_name_required: "اسم الشركة مطلوب",
          complete_profile_as_a_host: "متابعة التسجيل كمالك",
          //end popup

          //start profile
          show_web_as_customer: "إظهار الموقع كزبون",
          show_web_as_partner: "إظهار الموقع كشريك",
          personal_info: "المعلومات الشخصية",
          update_account: "تعديل المعلومات",
          complete: "إكمال التسجيل",
          complete_and_update: "المتابعة وتعديل المعلومات",
          update: "تعديل المعلومات",
          complete_as_client: "المتابعة كزبون",
          update_as_client: "تحديث معلومات الزبون",
          complete_as_host: "المتابعة كمالك",
          update_as_host: "تحديث معلومات المالك",
          complete_as_driver: "المتابعة كسائق",
          update_as_driver: "تحديث معلومات السائق",
          //end profile

          //start home
          hero_title_home: `تجربة الطريق 
            كما لم يحدث من قبل`,
          hero_desc_home: `اكتشف مغامرتك القادمة مع جيتتك. نحن هنا 
            لنقدم لك تجربة تأجير سيارات سلسة 
            لنبدأ رحلتك.`,
          view_all_cars:"اظهار كل السيارات",
          availability: "التوفر",
          availability_info:"نحن نضمن لك التوفر في اي وقت تحتاجه",
          comfort: "الراحة",
          comfort_info:"نحن نضمن لك الراحة في اي وقت تحتاجه",
          savings: "التخفيضات",
          savings_info:"نحن نضمن لك التخفيضات في اي وقت تحتاجه",
          our_services: "خدماتنا",
          our_services_info:"نحن نضمن لك خدماتنا في اي وقت تحتاجه",
          car_hire: "تاجير سيارات",
          car_hire_info:"نحن نضمن لك تاجير سيارات في اي وقت تحتاجه",
          car_sales: "بيع سيارات",
          car_sales_info:"نحن نضمن لك بيع سيارات في اي وقت تحتاجه",
          hire_driver: "تاجير سائق",
          hire_driver_info:"نحن نضمن لك تاجير سائق في اي وقت تحتاجه",
          best_cars: "السيارات الافضل",
          view_all: "عرض الكل",
          seats: "المقاعد",
          day: "اليوم",
          week: "الاسبوع",
          month: "الشهر",
          popular_cars: "الأكثر شهرة",
          no_cars: "لا يوجد سيارات",
          //end home
        }
      }
    },
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;
